import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorView from "../../status/ErrorView";

export interface TransactionInfoErrorBoundaryProps {
  children?: React.ReactNode;
}


function ErrorFallback() {
  return (
    <ErrorView
      errorMessage="transaction-info.error.default"
      errorHeader="errorView.title"
      displayTryAgain={false}
      iconType="ERROR"
    />
  );
}

export function TransactionInfoErrorBoundary({
  children,
}: TransactionInfoErrorBoundaryProps) {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      {children}
    </ErrorBoundary>
  );
}
